import Route from '@ember/routing/route'
import { service } from '@ember/service'
import { Precinct } from 'teacher-ui-client/utils/precincts'
import type LessonInfoService from 'teacher-ui-client/services/lesson-info'

export default class extends Route {
  @service lessonInfo!: LessonInfoService

  // Load in driving tests lesson data info, for any DT row activity descriptions. No need to await, data is tracked.
  beforeModel() {
    const precincts = [Precinct.RE_DRIVING_TESTS, Precinct.MS_DRIVING_TESTS]
    void this.lessonInfo.loadLessonInfoFor(precincts)
  }
}
